<template>
<nav class="navbar">
    <div class="logo">
        <router-link to="/"> <img :src="logo" :alt="brandName"></router-link>
    </div>

    <nav id="menu">
        <button class="nav-mobile" id="nav-mobile" @click="openMenu" :class="navOpen">
            <span></span>
            <span></span>
            <span></span>
        </button>
        <ul class="nav-menu" :class="navbarClass">
            <li class="nav-item dropdown-menu">
                <a @click="dropdown($event)" href="#" class="nav-link drop-menu">{{ usuario }}</a>
                <div class="dropdown-content-menu text-center">
                    <a href="#" @click="handleClick">
                        <div class="switch-theme" :class="{ 'active': isDark }" @click="toggleTheme">
                            <div class="toggle">
                                <i :class="'fa-solid fa-sun icon-day'" ></i>
                            </div>
                        </div>
                    </a>
                    <router-link to="/login" @click="closeSession">Cerrar sesión <i class="fa-solid fa-right-from-bracket"></i></router-link>
                </div>
            </li>
        </ul>
    </nav>
</nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    name: 'NavBar',
    
    data() {
        return {
            logo : process.env.VUE_APP_BRAND_LOGO_DARK,
            brandName : process.env.VUE_APP_BRAND_NAME,
            navbarClass: '',
            navOpen: '',
            usuario: '',
            isDark: false
        };
    },
    computed: {
        breadcrumbs() {
            return  this.$route.meta.breadcrumb;
        }
    },
    async mounted (){
        const isAuth = this.isAuth()
        if (!isAuth.error) {
            this.usuario = isAuth.username
        }
        const currentTheme = localStorage.getItem('theme') ? localStorage.getItem('theme') : null;

        if (currentTheme) {
            document.documentElement.setAttribute('data-theme', currentTheme);
            this.isDark = currentTheme == 'dark' ? true : false
        }

    },
    methods: {
        ...mapActions(['logout']),
        ...mapGetters(['user', 'isAuthenticated']),
        isAuth() {
            if (this.isAuthenticated()) {
                return {
                    'error': false,
                    'username': this.user().username
                }
            }
            return {'error': true}
        },
        async closeSession(event) {
            event.preventDefault()
            try {
                
                this.$loading({text: 'Cerrando sesión'})
                const response = await this.$request(this.$services.cerrar_session(), 'POST')
                if (response.status != 200) {
                    this.$loadingClose();
                    this.$alert({ type: 'error', text: this.$vars()['errorWs'] })
                    return
                }
                
                await this.logout();
                this.$router.push({ path: '/login' }).then(() => { this.$router.go(0) });
                this.$loadingClose();
            } catch (error) {
                console.error('Logout failed:', error);
                this.$loadingClose();
            }
        },
        openMenu(event) {
            if (!event.currentTarget.classList.contains('nav-open')) {
                this.navbarClass = 'open-menu'
                this.navOpen = 'nav-open'
                return
            }
            this.removerClase()
        },
        removerClase() {
            this.navbarClass = ''; // Resetear la clase
            this.navOpen = ''; // Resetear la clase
        },
        dropdown(event) {
            event.preventDefault();
        },
        toggleTheme() {
            this.isDark = !this.isDark;
            const switch_theme = document.querySelector('.switch-theme'),
            icon = switch_theme.querySelector('.icon-day')

            if (this.isDark) {

                icon.classList.remove('fa-sun')
                icon.classList.add('fa-moon')
                localStorage.setItem('theme', 'dark');
                document.documentElement.setAttribute('data-theme', 'dark');

                return
            }
            localStorage.setItem('theme', 'light');
            document.documentElement.setAttribute('data-theme', 'light');
            icon.classList.add('fa-sun')
            icon.classList.remove('fa-moon')
        },
        handleClick(event) {
            event.preventDefault();
        }
    },
    watch: {
        $route() {
            // Remover clase cuando cambia la ruta
            this.removerClase();
        }
    }
}
</script>
<style scoped>
.content-nav{
    position: fixed;
    top: 60px;
    left: 78px;
    width: calc(100% - 78px);
    transition: all 0.5s ease;
    background: var(--second-soft);
    height: 200px;
}
.sidebar.open~.content-nav {
    left: 250px;
    width: calc(100% - 250px);
}
/* ================================================================================================= //
// ----------------------------------------- SWITCH-THEME ------------------------------------------ //
// ================================================================================================= */
.switch-theme {
    width: 100px;
    height: 45px;
    background: var(--dark);
    border-radius: 50px;
    position: relative;
    box-shadow: inset 8px 8px 15px #151515,
                inset -8px -8px 15px #2b2b2b;
    cursor: pointer;
    z-index: 222;
    /* margin-bottom: 2rem; */
    transition: background 0.3s ease;
}

.toggle {
    width: 38px;
    height: 38px;
    background: var(--yellow);
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease;
    box-shadow: 4px 4px 10px #151515,
                -4px -4px 10px #2b2b2b;
}
.switch-theme.active .toggle{
    background: var(--gray);
}
.switch-theme.active .toggle {
    left: 57px;
}

.toggle .icon-day {
    color: white;
    font-size: 20px;
    pointer-events: none;
}

/* ================================================================================================= //
// -------------------------------------------- Navbar --------------------------------------------- //
// ================================================================================================= */
.navbar {
    background: var(--second);
    height: 60px;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 101;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid var(--alternate);
}
.logo {
    width: 250px;
    padding-left: 1rem;
}
.logo a {
    display: block;
    text-decoration: none;
    text-align: center;
    color: #fff;
    font-weight: bold;
    line-height: 44px;
    font-size: 1.15rem;
}
.logo a img {
    height: 40px;
    width: auto;
    vertical-align: middle;
}
#menu {
    position: absolute;
    top: 60px;
    width: 100%;
}
#menu ul {
    max-height: 0;
    overflow: hidden;
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 14px;
}
#menu li {
    display: block;
    background: var(--second);
    text-align: center;
    border-bottom: 1px solid var(--second-dark);
}
#menu li .nav-link {
    display: block;
    color: #fff;
    text-decoration: none;
    line-height: 60px;
    padding: 0 26px;
    font-size: .95rem
}
.navbar .nav-item .nav-link:hover {
    background: var(--primary);
}
#menu .open-menu {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    max-height: 400px;
    transition: max-height 0.4s ease;
}
#nav-mobile {
    background: transparent;
    border: 0;
    cursor: pointer;
    float: right;
    width: 60px;
    height: 60px;
    position: absolute;
    right: 0;
    top: -60px;
    opacity: 0.6;
}
#nav-mobile.nav-open {
    opacity: 1;
}
#nav-mobile span {
    display: block;
    width: 60%;
    margin: 4px auto;
    height: 4px;
    background: var(--primary);
}
.nav-item.dropdown-menu:hover .dropdown-content-menu {
    max-height: 1000px;
    transition: max-height 1s ease-in-out;
}
.dropdown-content-menu {
    position: absolute;
    background-color: var(--bg-elements);
    min-width: 7.5rem;
    overflow: auto;
    box-shadow: 0px 8px 16px 0px rgba(120, 120, 120, 0.5);
    z-index: 1;
    width: 170px;
    border-radius: 0.5rem;
    right: 0;
    max-height: 0;
    overflow: hidden;
    transition: max-height .5s cubic-bezier(0, 1, 0, 1);
}
.dropdown-content-menu a {
    color: var(--text-color);
    padding: .75rem 1rem;
    text-decoration: none;
    display: block;
    text-align: left;
}
.dropdown-content-menu a:hover {
    color: var(--second);
    background-color: var(--alternate);
}

@media only screen and (min-width: 768px) {
    #nav-mobile {
        display: none;
    }
    #menu {
        width: auto;
        float: right;
        top: 0;
        position: relative;
    }
    #menu .open-menu {
        box-shadow: none;
    }
    #menu ul {
        max-height: inherit;
    }
    #menu li {
        float: left;
        border: 0;
        background: transparent;
    }
    #menu li .nav-link {
        display: block;
        color: var(--white);
        padding: 0 26px;
    }
}
@media (max-width: 768px) {
    .dropdown-content-menu{
        width: 100%;
    }
}
</style>